import React, { Suspense, lazy } from 'react';
import { generatePath, Route, Switch } from 'react-router-dom';
import routes from '../../routes';
import RegistrationWrapper from './RegistrationWrapper';

const FoodDonorCompleteRegistrationView = lazy(() => import('./FoodDonorCompleteRegistrationView'));
const ReceivingAgencyCompleteRegistrationView = lazy(() => import('./ReceivingAgencyCompleteRegistrationView'));
const CompleteRegistrationAccountChoose = lazy(() => import('./CompleteRegistrationAccountChoose'));

const foodDonors = generatePath(routes.completeRegistrationNew, { accountType: 'food-donor' });
const receivingAgencies = generatePath(routes.completeRegistrationNew, { accountType: 'receiving-agency' });

const CompleteRegistrationView = () => (
  <Suspense fallback={null}>
    <RegistrationWrapper>
      <Switch>
        <Route exact path={foodDonors} component={FoodDonorCompleteRegistrationView} />
        <Route exact path={receivingAgencies} component={ReceivingAgencyCompleteRegistrationView} />
        <Route component={CompleteRegistrationAccountChoose} />
      </Switch>
    </RegistrationWrapper>
  </Suspense>
);

export default CompleteRegistrationView;
